export const INFORMATION = "information"
export const CONFIRMATION = "confirmation"
export const N = "N"
export const OUI = "Oui"
export const NON = "Non"
export const NOUVELLE = "nouvelle"
export const CHANGEMENT = "changement"
